import { useEffect, useState } from 'react';
import { API_BASE } from '../api/client';
import Spinner from '../components/Spinner';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles.css';

export default function DevLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('afw.dev.token')) {
      window.location.href = '/portal/health';
    }
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/dev/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j?.error?.message || `HTTP ${r.status}`);
      if (!j?.token) throw new Error('missing token');
      localStorage.setItem('afw.dev.token', j.token);
      if (j?.mustChange) window.location.href = '/portal/change-password';
      else window.location.href = '/portal/health';
    } catch (e: any) {
      const raw = (e?.message || String(e) || '').trim();
      const pretty = /^invalid credentials$/i.test(raw) ? 'Invalid Credentials' : raw;
      setError(pretty);
    } finally { setLoading(false); }
  }

  return (
    <div>
      <Header showPortalLink={false} loginLabel="Developer Portal" />
      <div className="content" style={{ display: 'grid', placeItems: 'center', paddingTop: 24 }}>
        {loading && <Spinner label="Signing in..." />}
        <form onSubmit={submit} className="card" style={{ width: 420, padding: 22 }}>
          <div style={{ textAlign: 'center', marginBottom: 12 }}>
            <img src="/images/logo_small.png" alt="AfricaWeather" style={{ maxWidth: 140, height: 'auto', margin: '0 auto 8px auto', display: 'block' }} />
            <h2 style={{ margin: 0, fontSize: 18 }}>Developer Sign in</h2>
          </div>
          <input className="txt" placeholder="Username" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} style={{ width: '100%', marginBottom: 10 }} />
          <div style={{ position: 'relative', width: '100%', marginBottom: 10 }}>
            <input
              className="txt"
              type={showPw ? 'text' : 'password'}
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ width: '100%' }}
            />
            <button
              type="button"
              className="btn secondary"
              onClick={() => setShowPw(s => !s)}
              style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', padding: 4, fontSize: 12, lineHeight: 0, minWidth: 0 }}
              aria-label={showPw ? 'Hide password' : 'Show password'}
              title={showPw ? 'Hide password' : 'Show password'}
            >
              {showPw ? (
                // eye-off
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.76 20.76 0 0 1 5.06-6.14M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a20.77 20.77 0 0 1-3.06 4.22"/>
                  <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              ) : (
                // eye
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
          {error && <div style={{ color: 'crimson', marginTop: 4, marginBottom: 8, textAlign: 'center' }}>{error}</div>}
          <div style={{ display: 'grid', placeItems: 'center', marginTop: 6 }}>
            <button className="btn" disabled={loading || !username || !password} style={{ minWidth: 160 }}>Sign in</button>
          </div>
        </form>
      </div>
      <Footer showIndustries={false} />
    </div>
  );
}
